import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing } = redesignTheme;

export const headerSharedStyles = {
  actionButtonBase: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
    height: 35,
    padding: '8px 12px',
    border: 0,
    borderRadius: 12,
    backgroundColor: colors.primaryDark,
    color: colors.white,
    cursor: 'pointer',
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: 'normal',
    whiteSpace: 'nowrap',
    '&:hover': {
      opacity: 0.92,
    },
  },
  popper: {
    zIndex: 1303,
  },
} as const;

export const desktopOnlyAt = (collapseAt: number) => ({
  [`@media (max-width: ${collapseAt}px)`]: {
    display: 'none',
  },
});
